/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mcp_Demo_Browser_TabInputs */

const en_mcp_demo_browser_tab = /** @type {(inputs: Mcp_Demo_Browser_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI assistant`)
};

const es_mcp_demo_browser_tab = /** @type {(inputs: Mcp_Demo_Browser_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asistente de IA`)
};

/**
* | output |
* | --- |
* | "AI assistant" |
*
* @param {Mcp_Demo_Browser_TabInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mcp_demo_browser_tab = /** @type {((inputs?: Mcp_Demo_Browser_TabInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mcp_Demo_Browser_TabInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mcp_demo_browser_tab(inputs)
	return en_mcp_demo_browser_tab(inputs)
});